
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: ['pageStr', 'pageName', 'element'],
  setup() {},
})
